import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Textarea,
  Button,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { fetchVilUpdateRequest } from "../ipsStore/actions";
import PrimarySideHeader from "../../../components/PrimarySideHeader";

const RequestDetails = ({ isOpen, onClose, patientDetails }) => {
  const dispatch = useDispatch();
  const [requestAdditionalFiles, setRequestAdditionalFiles] = useState("");

  const handleViewFile = (fileUrl) => {
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    }
  };

  const handleRequest = () => {
    const payload = {
      action: "add_data_requested",
      tr_id: patientDetails?.id,
      remarks: requestAdditionalFiles,
    };

    dispatch(fetchVilUpdateRequest(payload));
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          <Text>Request Details</Text>
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody p={6}>
          <VStack spacing={4} align="stretch">
            <Box>
              <VStack spacing={2} align="stretch">
                <HStack justify="space-between">
                  <Text>
                    {patientDetails?.patient_passport_filename ||
                      "Patient Document"}
                  </Text>
                  <Text
                    as="a"
                    color="blue.500"
                    fontWeight="bold"
                    textDecoration="underline"
                    cursor="pointer"
                    onClick={() =>
                      handleViewFile(patientDetails?.patient_passport)
                    }
                  >
                    View
                  </Text>
                </HStack>
                {patientDetails?.attendant_passports?.map((passport, index) => (
                  <HStack key={index} justify="space-between">
                    <Text>
                      {patientDetails?.attendant_passport_filenames?.[index] ||
                        `Attender Document ${index + 1}`}
                    </Text>
                    <Text
                      as="a"
                      color="blue.500"
                      fontWeight="bold"
                      textDecoration="underline"
                      cursor="pointer"
                      onClick={() => handleViewFile(passport)}
                    >
                      View
                    </Text>
                  </HStack>
                ))}
              </VStack>
            </Box>

            <Box>
              <PrimarySideHeader mt="20px">
                Request Additional Files
              </PrimarySideHeader>
              <Textarea
                value={requestAdditionalFiles}
                onChange={(e) => setRequestAdditionalFiles(e.target.value)}
                placeholder="Enter your request details here..."
                size="sm"
                rows={4}
              />
            </Box>

            <Button
              colorScheme="blue"
              onClick={handleRequest}
              alignSelf="flex-end"
              mt={4}
            >
              Request
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default RequestDetails;
